export const getCurrentPlayerProfileIds = (playerInfo, routePlayerId) => {
  const isCurrentProfile =
    playerInfo?.id &&
    routePlayerId &&
    String(playerInfo.id) === String(routePlayerId)

  return {
    accountId: isCurrentProfile ? playerInfo.id : null,
    userId: isCurrentProfile ? playerInfo.userId : null,
  }
}
